var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Type } from './Type';
import { Int } from './Int';
var FixedFloat = /** @class */ (function (_super) {
    __extends(FixedFloat, _super);
    function FixedFloat(fractionDigits, minValue) {
        var _this = _super.call(this) || this;
        fractionDigits = fractionDigits || 0;
        _this._mult = Math.pow(10, fractionDigits);
        _this._int = new Int(typeof minValue === 'number' ? minValue * _this._mult : undefined);
        return _this;
    }
    FixedFloat.prototype.encodeBuffer = function (value, buffer) {
        this._int.encodeBuffer(Math.round(value * this._mult), buffer);
    };
    FixedFloat.prototype.decodeBuffer = function (buffer) {
        return this._int.decodeBuffer(buffer) / this._mult;
    };
    return FixedFloat;
}(Type));
export { FixedFloat };
